import styled from 'styled-components';
import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { ReactComponent as TravelBackgroundMapElements } from '@images/travel/Travel_Background_Elements.svg';

export const DesktopLazyLoadWrapper = styled.div`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const MobileLazyLoadWrapper = styled.div`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: auto;
  }
`;

export const BackgroundStyledPlaceholderCloudImage = styled(PlaceholderCloudImage)``;

export const RecommendStyledPlaceholderCloudImage = styled(PlaceholderCloudImage)``;

export const StyledTravelBackgroundMapElements = styled(TravelBackgroundMapElements)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const MainTextPairing = styled(TextPairing)`
  margin: auto;
  max-width: 717px;
  .text-pairing-title {
    max-width: 450px;
    ${themeMediaQuery('xl')} {
      max-width: 500px;
    }
  }
`;

export const BookingAssistantTextPairing = styled(TextPairing)`
  max-width: 294px;
  margin: auto;
  ${themeMediaQuery('sm')} {
    max-width: 439px;
  }
  .text-pairing-eyebrow {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .text-pairing-body {
    max-width: 375px;
    ${themeMediaQuery('below_sm')} {
      max-width: 254px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .text-pairing-title {
    max-width: 350px;
    ${themeMediaQuery('below_sm')} {
      max-width: 254px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    ${themeMediaQuery('xl')} {
      max-width: 420px;
    }
  }
`;

export const TravelRecommendationsTextPairing = styled(TextPairing)`
  max-width: 294px;
  margin: auto;
  ${themeMediaQuery('sm')} {
    max-width: 475px;
  }
  .text-pairing-eyebrow {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .text-pairing-body {
    max-width: 375px;
    ${themeMediaQuery('below_sm')} {
      max-width: 247px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .text-pairing-title {
    max-width: 330px;
    ${themeMediaQuery('below_sm')} {
      max-width: 265px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    ${themeMediaQuery('xl')} {
      max-width: 420px;
    }
  }
`;

export const MapAndAppTextPairing = styled(TextPairing)`
  max-width: 294px;
  margin: auto;
  ${themeMediaQuery('sm')} {
    max-width: 425px;
  }
  .text-pairing-eyebrow {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .text-pairing-body {
    max-width: 372px;
    ${themeMediaQuery('below_sm')} {
      max-width: 247px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .text-pairing-title {
    max-width: 260px;
    ${themeMediaQuery('below_sm')} {
      max-width: 265px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    ${themeMediaQuery('xl')} {
      max-width: 320px;
    }
  }
`;

export const StyledContentBox = styled(Box)`
  overflow: hidden;
  position: relative;
`;

export const BackgroundImageContainer = styled.div`
  transform: translate3d(0px, 0px, 0px) scale(1.0039, 1.0039);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, rgba(254, 243, 234, 0) 0%, #fef3ea 100%);
  background-size: cover;
  z-index: -1;
  > svg,
  > img {
    position: absolute;
    top: 0;
    display: block;
    min-height: 100%;
    min-width: 100%;
    left: 50%;
    transform: translate(-50%);
  }
  > svg {
    ${themeMediaQuery('below_sm')} {
      width: 480px;
      top: 400px;
      min-width: 50%;
    }
    .Travel_Background_Elements_svg__from_to_path_line {
      stroke-dashoffset: 1048;
      animation: dash 6s linear forwards;
    }
    @keyframes dash {
      to {
        stroke-dashoffset: 0;
      }
    }
    .Travel_Background_Elements_svg {
      &__pointer_from_pt1,
      &__pointer_from_pt2 {
        opacity: 0;
        transform: translateY(-500px);
        transition: opacity 0s, transform 0.25s ease-in-out;
      }
      &__pointer_to_pt1,
      &__pointer_to_pt2 {
        opacity: 0;
        transform: translateY(-500px);
        transition: opacity 0s 0.3s, transform 0.25s ease-in-out 0.3s;
      }
    }

    &.animate-pointers {
      .Travel_Background_Elements_svg {
        &__pointer_to_pt1,
        &__pointer_to_pt2,
        &__pointer_from_pt1,
        &__pointer_from_pt2 {
          opacity: 1;
          transform: translateY(0);
        }
      }
    }
  }
`;

export const MapAndAppImagesBlock = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 300px;
  img {
    margin-right: auto;
    max-width: 100%;
  }
  img:nth-child(2) {
    margin-top: -30px;
    margin-left: ${themeSpace(6)};
    ${themeMediaQuery('sm')} {
      margin-bottom: -30px;
      margin-left: ${themeSpace(10)};
    }
  }
  ${themeMediaQuery('below_sm')} {
    height: auto;
    min-height: 340px;
  }
`;

export const ImageColumn = styled(Columns.Column)<{ style?: React.CSSProperties }>`
  height: 498px;
  > img {
    display: block;
    margin: auto;
  }
  ${themeMediaQuery('below_sm')} {
    height: auto;
  }
`;

export const TextColumn = styled(Columns.Column)``;

export const ReversedBlockColumns = styled(Columns)`
  ${themeMediaQuery('sm')} {
    ${ImageColumn} {
      order: 1;
    }
  }
`;

export const DesktopPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const MobilePlaceholderCloudImage = styled(PlaceholderCloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;
